import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import jwt_decode from "jwt-decode";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import DatePicker from "react-datepicker";

class SupportTicketSummary extends Component {
    render() {
        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Support Tickets Summary</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>

                                <div className=" content bgcolor">
                                    <div className=" container-fluid ">

                                        <div className="p-10">
                                            <div className="">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <table className="table table-striped table-hover">
                                                            <thead>
                                                            <tr>
                                                                <th>S. No</th>
                                                                <th>Issue Type</th>
                                                                <th>Number Of Tickets</th>
                                                                <th>Avg. Time Taken For Resolution</th>
                                                                <th>Status</th>
                                                                <th>Number of Tickets</th>
                                                                <th>Status</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td>Hardware Issue</td>
                                                                <td>200</td>
                                                                <td>35 Min</td>
                                                                <td>Resolved</td>
                                                                <td>23</td>
                                                                <td>Open</td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td>Software Issue</td>
                                                                <td>190</td>
                                                                <td>60 Min</td>
                                                                <td>Resolved</td>
                                                                <td>40</td>
                                                                <td>Open</td>
                                                            </tr>
                                                            <tr>
                                                                <td>3</td>
                                                                <td>Terminal Issue</td>
                                                                <td>50</td>
                                                                <td>80 Min</td>
                                                                <td>Resolved</td>
                                                                <td>70</td>
                                                                <td>Open</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="">

                                                        <div className="clearfix"></div>
                                                        <div className="gap_ver"></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SupportTicketSummary;